// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Itinerary-space1-YwQui {
	margin-bottom: 6px !important;
}

.Itinerary-space2-I3NhC {
	margin-bottom: 12px !important;
}

.Itinerary-space3-Q8m0w {
	margin-bottom: 18px !important;
}

.Itinerary-space4-zexuM {
	margin-bottom: 24px !important;
}

.Itinerary-space5-gykC8 {
	margin-bottom: 30px !important;
}

.Itinerary-space6-hQSp5 {
	margin-bottom: 36px !important;
}

.Itinerary-space7-zwZ6F {
	margin-bottom: 42px !important;
}

.Itinerary-spaceTop8-wqdW6 {
	margin-bottom: 48px !important;
}

.Itinerary-spaceTop1-h5MvK {
	margin-top: 6px !important;
}

.Itinerary-spaceTop2-lmB0a {
	margin-top: 12px !important;
}

.Itinerary-spaceTop3-h_owc {
	margin-top: 18px !important;
}

.Itinerary-spaceTop4-v1Toz {
	margin-top: 24px !important;
}

.Itinerary-spaceTop5-gFeiC {
	margin-top: 30px !important;
}

.Itinerary-spaceTop6-vScLT {
	margin-top: 36px !important;
}

.Itinerary-spaceTop7-GDhab {
	margin-top: 42px !important;
}

.Itinerary-spaceTop8-wqdW6 {
	margin-top: 48px !important;
}

.Itinerary-noMargin-TYU6V {
	margin: 0px !important;
}

.Itinerary-padding1-Mmka0 {
	padding-bottom: 6px !important;
}

.Itinerary-padding2-AEuq6 {
	padding-bottom: 12px !important;
}

.Itinerary-padding3-evbJj {
	padding-bottom: 18px !important;
}

.Itinerary-padding4-wmEeB {
	padding-bottom: 24px !important;
}

.Itinerary-padding5-jNMV8 {
	padding-bottom: 30px !important;
}

.Itinerary-padding6-TSuYQ {
	padding-bottom: 36px !important;
}

.Itinerary-padding7-IKPuL {
	padding-bottom: 42px !important;
}

.Itinerary-paddingTop1-RS3wn {
	padding-top: 6px !important;
}

.Itinerary-paddingTop2-J6bWS {
	padding-top: 12px !important;
}

.Itinerary-paddingTop3-Nfekq {
	padding-top: 18px !important;
}

.Itinerary-paddingTop4-u7CQt {
	padding-top: 24px !important;
}

.Itinerary-paddingTop5-dK58y {
	padding-top: 30px !important;
}

.Itinerary-paddingTop6-Ed1Lz {
	padding-top: 36px !important;
}

.Itinerary-paddingTop7-o7ou5 {
	padding-top: 42px !important;
}

.Itinerary-noPadding-Cfm4l {
	padding: 0px !important;
}

.Itinerary-textBold-z3Q6U {
	font-weight: 500 !important;
}

.Itinerary-textBolder-hvcO8 {
	font-weight: 700 !important;
}

.Itinerary-textNormal-cNlGN {
	font-weight: normal !important;
}

.Itinerary-spaceBottom20-Dx4EC {
	margin-bottom: 20px;
}

.Itinerary-spaceBottom10-WzfcH {
	margin-bottom: 10px;
}

.Itinerary-marginNone-QBKae {
	margin: 0;
}

.Itinerary-spaceBottom15-I5UsY {
	margin-bottom: 15px;
}

.Itinerary-marginTopNone-YK7ZF {
	margin-top: 0;
}

.Itinerary-spaceTop11-T_Bc4 {
	margin-top: 11px;
}

.Itinerary-spaceTop21-xSkbh {
	margin-top: 21px;
}

.Itinerary-spaceTop20-UurIb {
	margin-top: 20px;
}

.Itinerary-spaceTop10-x4OQE {
	margin-top: 10px;
}

/*New Design Text Colors */

.Itinerary-textDarkBlue-L3hXB {
	color: rgb(20, 39, 94) !important;
}

.Itinerary-textLightBlue-k4GPo {
	color: rgb(57, 87, 106) !important;
}

.Itinerary-textLightSandleGreen-rxayH {
	color: rgb(76, 86, 41) !important;
}

.Itinerary-textLightBrown-rx9Sb {
	color: rgb(115, 79, 33) !important;
}

.Itinerary-textMediumMaroon-XwAuu {
	color: rgb(87, 37, 51) !important;
}

.Itinerary-textBrown-cl4MS {
	color: rgb(160, 47, 24) !important;
}

.Itinerary-textMaroon-OcY3s {
	color: rgb(155, 49, 67) !important;
}

.Itinerary-textDarkBrown-zbZoJ {
	color: rgb(83, 18, 16) !important;
}

.Itinerary-textMediumBrown-mVPl8 {
	color: rgb(142, 28, 10) !important;
}

.Itinerary-textSkyBlue-_wEYi {
	color: rgb(37, 117, 141) !important;
}

.Itinerary-textGray-H4vXk {
	color: rgb(77, 65, 51) !important;
}

.Itinerary-landingContainer-bBmzR {
	max-width: var(--max-container-width);
	margin: 0 auto;
}

.Itinerary-titleText-w8ZZE {
	font-size: 26px;
	font-weight: 600;
	margin: 0px 0px 6px;
}

.Itinerary-parent-r2uXX {
	background: var(--secondary-gray-bg) none repeat scroll 0 0;
	padding-top: 71.6667%;
	position: relative;
	border-radius: 15px;
}

.Itinerary-children-tG0jb {
	bottom: 0;
	height: 100%;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
	width: 100%;
}

.Itinerary-content-pfAPu {
	height: 100%;
	width: 100%;
	position: relative;
}

.Itinerary-imageContent-skoT0 {
	height: 100%;
	width: 100%;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-size: cover;
	position: absolute;
	border-radius: 15px;
}

.Itinerary-profileAvatarLink-or1GQ {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	overflow: hidden;
	border-radius: 50%;
	background-color: var(--secondary-gray-bg);
	border: 2px solid var(--primary-border);
}

.Itinerary-profileAvatar-Yo63y {
	height: 63px;
	width: 63px;
}

.Itinerary-textWidth-fhUWd {
	word-break: break-word;
}

.Itinerary-avatarDisplayFlex-S5QSb {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: start;
	    -ms-flex-pack: start;
	        justify-content: flex-start;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.Itinerary-hostedTitle-Ab1Nt {
	margin: 10px 0px 0px;
	font-size: 18px;
	font-weight: 500;
	color: var(--primary-foreground);
	display: block;
}

.Itinerary-detailsSection-UPbhN {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
	padding: 25px;
	width: 100%;
}

.Itinerary-biilingGrid-Ul0f1 {
	display: grid;
	grid-template-columns: 66% 34%;
}

.Itinerary-subText-afcV1 {
	font-size: 16px;
}

.Itinerary-textBoldMedium-QSrhB {
	font-weight: 500;
}

.Itinerary-rightArrow-itYai {
	width: 6px;
	height: 12px;
	margin-left: 4px;
}

.Itinerary-linkText-t2r7P,
.Itinerary-linkText-t2r7P:hover,
.Itinerary-linkText-t2r7P:focus,
.Itinerary-linkText-t2r7P:active {
	color: var(--primary-link-foreground);
	text-decoration: underline;
	font-size: 16px;
}

.Itinerary-hostTitlePadding-gKL3N {
	padding-left: 15px;
}

.Itinerary-locationText-rBx6l {
	font-size: 14px;
	color: var(--secondary-foreground);
	margin: 3px 0px 5px 0px;
}

.Itinerary-hrLine-Hkk9e {
	margin: 18px 0px;
	border-top: 1px solid var(--primary-border);
}

.Itinerary-dateGrid-psPsH {
	display: grid;
	grid-template-columns: 40% 26% 34%;
}

.Itinerary-dateText-MV9WK {
	font-size: 16px;
	color: var(--secondary-foreground);
}

.Itinerary-displayBlock-s2ixj {
	display: block;
}

.Itinerary-starSection-TVKrP {
	display: inline-block;
	vertical-align: middle;
	padding-right: 2px;
}

.Itinerary-dateArrow-YOXbm {
	width: 42px;
	height: 42px;
	margin-top: 15px;
}

.Itinerary-reviewCircle-mutOj {
	position: relative;
	margin-left: 12px;
}

.Itinerary-reviewCircle-mutOj::before {
	content: '';
	position: absolute;
	left: -7px;
	top: 7px;
	width: 3px;
	height: 3px;
	background-color: var(--primary-foreground);
	border-radius: 50%;
}

.Itinerary-itineraryReview-x3tWW {
	margin: 15px 0 6px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.Itinerary-hostTitleTwo-WUrew {
	margin-top: 15px;
}

@media screen and (max-width: 767px) {
	.Itinerary-biilingGrid-Ul0f1 {
		grid-template-columns: 100%;
	}

	.Itinerary-detailsSection-UPbhN {
		margin-bottom: 30px;
	}
}

@media screen and (min-width:768px) {
	.Itinerary-billingPadding-SiSV9 {
		padding-right: 60px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Itinerary/Itinerary.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,qCAAqC;CACrC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,2DAA2D;CAC3D,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,YAAY;CACZ,OAAO;CACP,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,4BAA4B;CAC5B,4BAA4B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB,0CAA0C;CAC1C,uCAAuC;AACxC;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,uBAA2B;KAA3B,oBAA2B;SAA3B,2BAA2B;CAC3B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,cAAc;AACf;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,gBAAgB;AACjB;;AAEA;;;;CAIC,qCAAqC;CACrC,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,2CAA2C;AAC5C;;AAEA;CACC,aAAa;CACb,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,UAAU;CACV,WAAW;CACX,2CAA2C;CAC3C,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,mBAAmB;CACpB;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.landingContainer {\n\tmax-width: var(--max-container-width);\n\tmargin: 0 auto;\n}\n\n.titleText {\n\tfont-size: 26px;\n\tfont-weight: 600;\n\tmargin: 0px 0px 6px;\n}\n\n.parent {\n\tbackground: var(--secondary-gray-bg) none repeat scroll 0 0;\n\tpadding-top: 71.6667%;\n\tposition: relative;\n\tborder-radius: 15px;\n}\n\n.children {\n\tbottom: 0;\n\theight: 100%;\n\tleft: 0;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\twidth: 100%;\n}\n\n.content {\n\theight: 100%;\n\twidth: 100%;\n\tposition: relative;\n}\n\n.imageContent {\n\theight: 100%;\n\twidth: 100%;\n\tbackground-position: 50% 50%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tposition: absolute;\n\tborder-radius: 15px;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 2px solid var(--primary-border);\n}\n\n.profileAvatar {\n\theight: 63px;\n\twidth: 63px;\n}\n\n.textWidth {\n\tword-break: break-word;\n}\n\n.avatarDisplayFlex {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n}\n\n.hostedTitle {\n\tmargin: 10px 0px 0px;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tcolor: var(--primary-foreground);\n\tdisplay: block;\n}\n\n.detailsSection {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n\tpadding: 25px;\n\twidth: 100%;\n}\n\n.biilingGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 66% 34%;\n}\n\n.subText {\n\tfont-size: 16px;\n}\n\n.textBoldMedium {\n\tfont-weight: 500;\n}\n\n.rightArrow {\n\twidth: 6px;\n\theight: 12px;\n\tmargin-left: 4px;\n}\n\n.linkText,\n.linkText:hover,\n.linkText:focus,\n.linkText:active {\n\tcolor: var(--primary-link-foreground);\n\ttext-decoration: underline;\n\tfont-size: 16px;\n}\n\n.hostTitlePadding {\n\tpadding-left: 15px;\n}\n\n.locationText {\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n\tmargin: 3px 0px 5px 0px;\n}\n\n.hrLine {\n\tmargin: 18px 0px;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.dateGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 40% 26% 34%;\n}\n\n.dateText {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\n.displayBlock {\n\tdisplay: block;\n}\n\n.starSection {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tpadding-right: 2px;\n}\n\n.dateArrow {\n\twidth: 42px;\n\theight: 42px;\n\tmargin-top: 15px;\n}\n\n.reviewCircle {\n\tposition: relative;\n\tmargin-left: 12px;\n}\n\n.reviewCircle::before {\n\tcontent: '';\n\tposition: absolute;\n\tleft: -7px;\n\ttop: 7px;\n\twidth: 3px;\n\theight: 3px;\n\tbackground-color: var(--primary-foreground);\n\tborder-radius: 50%;\n}\n\n.itineraryReview {\n\tmargin: 15px 0 6px;\n\tdisplay: flex;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.hostTitleTwo {\n\tmargin-top: 15px;\n}\n\n@media screen and (max-width: 767px) {\n\t.biilingGrid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.detailsSection {\n\t\tmargin-bottom: 30px;\n\t}\n}\n\n@media screen and (min-width:768px) {\n\t.billingPadding {\n\t\tpadding-right: 60px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Itinerary-space1-YwQui`,
	"space2": `Itinerary-space2-I3NhC`,
	"space3": `Itinerary-space3-Q8m0w`,
	"space4": `Itinerary-space4-zexuM`,
	"space5": `Itinerary-space5-gykC8`,
	"space6": `Itinerary-space6-hQSp5`,
	"space7": `Itinerary-space7-zwZ6F`,
	"spaceTop8": `Itinerary-spaceTop8-wqdW6`,
	"spaceTop1": `Itinerary-spaceTop1-h5MvK`,
	"spaceTop2": `Itinerary-spaceTop2-lmB0a`,
	"spaceTop3": `Itinerary-spaceTop3-h_owc`,
	"spaceTop4": `Itinerary-spaceTop4-v1Toz`,
	"spaceTop5": `Itinerary-spaceTop5-gFeiC`,
	"spaceTop6": `Itinerary-spaceTop6-vScLT`,
	"spaceTop7": `Itinerary-spaceTop7-GDhab`,
	"noMargin": `Itinerary-noMargin-TYU6V`,
	"padding1": `Itinerary-padding1-Mmka0`,
	"padding2": `Itinerary-padding2-AEuq6`,
	"padding3": `Itinerary-padding3-evbJj`,
	"padding4": `Itinerary-padding4-wmEeB`,
	"padding5": `Itinerary-padding5-jNMV8`,
	"padding6": `Itinerary-padding6-TSuYQ`,
	"padding7": `Itinerary-padding7-IKPuL`,
	"paddingTop1": `Itinerary-paddingTop1-RS3wn`,
	"paddingTop2": `Itinerary-paddingTop2-J6bWS`,
	"paddingTop3": `Itinerary-paddingTop3-Nfekq`,
	"paddingTop4": `Itinerary-paddingTop4-u7CQt`,
	"paddingTop5": `Itinerary-paddingTop5-dK58y`,
	"paddingTop6": `Itinerary-paddingTop6-Ed1Lz`,
	"paddingTop7": `Itinerary-paddingTop7-o7ou5`,
	"noPadding": `Itinerary-noPadding-Cfm4l`,
	"textBold": `Itinerary-textBold-z3Q6U`,
	"textBolder": `Itinerary-textBolder-hvcO8`,
	"textNormal": `Itinerary-textNormal-cNlGN`,
	"spaceBottom20": `Itinerary-spaceBottom20-Dx4EC`,
	"spaceBottom10": `Itinerary-spaceBottom10-WzfcH`,
	"marginNone": `Itinerary-marginNone-QBKae`,
	"spaceBottom15": `Itinerary-spaceBottom15-I5UsY`,
	"marginTopNone": `Itinerary-marginTopNone-YK7ZF`,
	"spaceTop11": `Itinerary-spaceTop11-T_Bc4`,
	"spaceTop21": `Itinerary-spaceTop21-xSkbh`,
	"spaceTop20": `Itinerary-spaceTop20-UurIb`,
	"spaceTop10": `Itinerary-spaceTop10-x4OQE`,
	"textDarkBlue": `Itinerary-textDarkBlue-L3hXB`,
	"textLightBlue": `Itinerary-textLightBlue-k4GPo`,
	"textLightSandleGreen": `Itinerary-textLightSandleGreen-rxayH`,
	"textLightBrown": `Itinerary-textLightBrown-rx9Sb`,
	"textMediumMaroon": `Itinerary-textMediumMaroon-XwAuu`,
	"textBrown": `Itinerary-textBrown-cl4MS`,
	"textMaroon": `Itinerary-textMaroon-OcY3s`,
	"textDarkBrown": `Itinerary-textDarkBrown-zbZoJ`,
	"textMediumBrown": `Itinerary-textMediumBrown-mVPl8`,
	"textSkyBlue": `Itinerary-textSkyBlue-_wEYi`,
	"textGray": `Itinerary-textGray-H4vXk`,
	"landingContainer": `Itinerary-landingContainer-bBmzR`,
	"titleText": `Itinerary-titleText-w8ZZE`,
	"parent": `Itinerary-parent-r2uXX`,
	"children": `Itinerary-children-tG0jb`,
	"content": `Itinerary-content-pfAPu`,
	"imageContent": `Itinerary-imageContent-skoT0`,
	"profileAvatarLink": `Itinerary-profileAvatarLink-or1GQ`,
	"profileAvatar": `Itinerary-profileAvatar-Yo63y`,
	"textWidth": `Itinerary-textWidth-fhUWd`,
	"avatarDisplayFlex": `Itinerary-avatarDisplayFlex-S5QSb`,
	"hostedTitle": `Itinerary-hostedTitle-Ab1Nt`,
	"detailsSection": `Itinerary-detailsSection-UPbhN`,
	"biilingGrid": `Itinerary-biilingGrid-Ul0f1`,
	"subText": `Itinerary-subText-afcV1`,
	"textBoldMedium": `Itinerary-textBoldMedium-QSrhB`,
	"rightArrow": `Itinerary-rightArrow-itYai`,
	"linkText": `Itinerary-linkText-t2r7P`,
	"hostTitlePadding": `Itinerary-hostTitlePadding-gKL3N`,
	"locationText": `Itinerary-locationText-rBx6l`,
	"hrLine": `Itinerary-hrLine-Hkk9e`,
	"dateGrid": `Itinerary-dateGrid-psPsH`,
	"dateText": `Itinerary-dateText-MV9WK`,
	"displayBlock": `Itinerary-displayBlock-s2ixj`,
	"starSection": `Itinerary-starSection-TVKrP`,
	"dateArrow": `Itinerary-dateArrow-YOXbm`,
	"reviewCircle": `Itinerary-reviewCircle-mutOj`,
	"itineraryReview": `Itinerary-itineraryReview-x3tWW`,
	"hostTitleTwo": `Itinerary-hostTitleTwo-WUrew`,
	"billingPadding": `Itinerary-billingPadding-SiSV9`
};
module.exports = ___CSS_LOADER_EXPORT___;
